import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'gatsby';
import Img from 'gatsby-image';
import cx from 'classnames';
import AspectRatioImage from '../AspectRatioImage/AspectRatioImage';
import {pressReleaseTypes} from '../../types/types';
import './Card.less';

const CardBottom = ({title, publicationDate, teaserText, size}) => {
    if (size === 'small') {
        return (
            <>
                <h1 className="Card__heading h4">
                    <span>{title}</span>
                </h1>
                <p className="text-default">{publicationDate}</p>
            </>
        );
    }

    return (
        <>
            <h1 className="Card__heading h3">
                <span>{title}</span>
            </h1>
            <p>
                <strong>{publicationDate}</strong>
            </p>
            {teaserText && (
                <p className="text-default">{teaserText.teaserText}</p>
            )}
        </>
    );
};

CardBottom.propTypes = {
    title: PropTypes.string.isRequired,
    publicationDate: PropTypes.string.isRequired,
    teaserText: PropTypes.objectOf(PropTypes.string),
    size: PropTypes.oneOf(['small']),
};

export default function Card({route, featuredImage, size, ...rest}) {
    const withFeaturedImage =
        featuredImage && featuredImage.image && featuredImage.image.fluid;

    return (
        <article className={cx('Card', size && `Card--${size}`)}>
            <Link to={`/${route}`} className="Card__top Card__section">
                <AspectRatioImage>
                    {withFeaturedImage && (
                        <Img
                            fluid={featuredImage.image.fluid}
                            alt={featuredImage.description}
                            style={{position: 'absolute'}}
                        />
                    )}
                </AspectRatioImage>
            </Link>
            <div className="Card__bottom Card__section">
                <Link to={`/${route}`}>
                    <CardBottom {...rest} size={size} />
                </Link>
            </div>
        </article>
    );
}

Card.propTypes = {
    ...pressReleaseTypes,
    teaserText: PropTypes.objectOf(PropTypes.string),
    size: PropTypes.oneOf(['small']),
};
